import { render, staticRenderFns } from "./usergroup-vehicle-info-business-notes.vue?vue&type=template&id=3b0d57db&scoped=true"
import script from "./usergroup-vehicle-info-business-notes.vue?vue&type=script&lang=js"
export * from "./usergroup-vehicle-info-business-notes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0d57db",
  null
  
)

export default component.exports